var getAccountTitle = function (portfolio) {
    return portfolio === "INSTALLMENT_LOAN" ? "labels.loan" : "labels.account";
};
export default getAccountTitle;
